import React, { useMemo } from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { getBranchMasterExcelColDefs } from './BrnchMasterConstant';
import { useTranslation } from '../../../../i18n/I18nProvider';

const BranchMAsterExcelTable = (props) => {
    const { tableData,  loginData } = props
    const { translations } = useTranslation()
    const bum = translations?.branchAndUserMaster || {}
    const cs = translations?.common || {}
  // Memoize column definitions
  const columnDefs = useMemo(() => getBranchMasterExcelColDefs(translations), [translations]);

  return (
      <TableContainer className='scrollBlue' component={Paper} sx={{ display:'none',maxHeight: '70vh', marginBottom: "5px" }}>
          <Table id='cityPairExelTbl' stickyHeader size="small" aria-label="a dense table">
              <TableHead sx={{ position: 'sticky', top: 0, zIndex: 2 }}>
                  <TableRow>
                      <TableCell
                          className="reportTD"
                          style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
                          colSpan={7}

                      >
                          <h3 style={{ paddingLeft: '17px', fontFamily: 'Roboto', fontSize: '18px' }}>{bum.branchMasterDetails || 'Branch Master Details'}</h3>
                      </TableCell>
                      <TableCell
                          className="reportTD"
                          style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '500', textAlign: 'right' }}
                          colSpan={7}

                      >
                          <h3 style={{ paddingLeft: '17px', fontFamily: 'Roboto', fontSize: '18px' }}>{cs.companyName || bum.companyName || 'Company Name'} : {loginData.strCompanyName}</h3>
                      </TableCell>
                  </TableRow>
                  <TableRow >
                  <TableCell  colSpan={14}></TableCell>
                  </TableRow>
                  <TableRow>
                      {columnDefs.map((col, index) => (
                          <TableCell key={`TH-${index}`} style={{ ...col.headerSx, backgroundColor: '#DAEDFE', padding: '8px 6px !important', minHeight: '36px !important', fontSize: '14px', fontWeight: '700', color: '#444' }}>
                              {col.headerName}
                          </TableCell>
                      ))}
                  </TableRow>
              </TableHead>
                 {tableData?.length > 0 ? <TableBody>
                        {tableData?.map((val, index) => (
                            <TableRow key={`CityPairDataCol-${index}`}>
                                {columnDefs.map((col, index1) => (
                                    <TableCell
                                        key={`CityPairDataCol-${index}-${index1}`}
                                        style={{
                                            ...col.headerSx,
                                            height: '40px',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#444',
                                        }}
                                    >
                                        {val?.[col.field]}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody> :
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={columnDefs?.length}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            marginTop: '20px',
                                            marginBottom: '20px',
                                            color: 'red',
                                            fontSize: '14px',
                                        }}
                                    >
                                        <span>{bum.noResultsFoundForTheSelectedFilters || 'No Results Found For The Selected Filters.'}</span>
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableBody>}
          </Table>
      </TableContainer>
  );
}

export default BranchMAsterExcelTable
